"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { recordRouteBreadcrumb } from "@/app/_helpers/errorBreadcrumbs";

export function NavigationEvents({ onNavigate, user }: any) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const search = searchParams?.toString();
    recordRouteBreadcrumb(search ? `${pathname}?${search}` : pathname ?? "");
  }, [pathname, searchParams]);

  useEffect(() => {
    if (!user) {
      if (pathname === "/login" || pathname === "/reset") {
        onNavigate();
      }

      return;
    } else {
      if (user.signup?.status === "pending") {
        if (pathname === "/signup" || pathname === "/signup/complete") onNavigate();
        return;
      }
      if (!user.onboarded && pathname !== "/onboarding") {
        return;
      } else {
        onNavigate();
      }
    }
  }, [pathname, searchParams, user, onNavigate]);

  return null;
}
